import styles from "./Liquidity.module.css"
import RepositionModal from "../../components/Reposition/RepositionModal/RepositionModal"

import { LiquidityHeader, CurrencyConverter, ExtraInfo, Button, PoolSelector, FeeTier, AmbientToggle, MinMaxPrice } from "../../components"
import ContentContainer from "../../components/misc/ContentContainer/ContentContainer"


const Liquidity = () => {

    const ButtonDisplay = (
        <div className={styles.button_container}>

            <Button title="Enter An Amount" disabled />
        </div>
    )

  return (
    
          <ContentContainer>


              <LiquidityHeader />
              <CurrencyConverter isLiq />
              <AmbientToggle/>
              
              <FeeTier />
              <MinMaxPrice/>
    

                {/* <ExtraInfo/> */}
              {ButtonDisplay}
          </ContentContainer>

     
  )
}

export default Liquidity